import { createTheme, ThemeOptions } from '@mui/material/styles'
import * as CSS from 'csstype'
import { defaultThemeOptions } from './DefaultTheme'

/* const COLOR_DARKEST_BLUE = '#0F0F25' */
const COLOR_LIGHT_BLUE = '#82CCF1'
const COLOR_BRIGHT_YELLOW = '#FBB830'
/* const COLOR_PLEASANT_BLUE = '#232F74' */
const COLOR_MEDIUM_BLUE = '#161C42'
const COLOR_READABLE_TEXT = '#ffffff'
const COLOR_READABLE_TEXT_CONTRAST = '#222222'

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#029F9B',
      contrastText: COLOR_READABLE_TEXT
    },
    background: {
      default: COLOR_MEDIUM_BLUE,
      paper: COLOR_MEDIUM_BLUE
    },
    info: {
      main: COLOR_BRIGHT_YELLOW
    },
    text: {
      primary: COLOR_READABLE_TEXT,
      secondary: COLOR_LIGHT_BLUE
    },
    divider: `${COLOR_READABLE_TEXT}30`
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '24px',
          border: 0,
          textTransform: 'none' as CSS.Property.TextTransform,
          whiteSpace: 'nowrap' as CSS.Property.WhiteSpace
        },
        containedPrimary: {
          background:
            'linear-gradient(94.54deg, #029F9B 12.07%, #0C7D96 53.97%, #335591 98.87%)',
          color: COLOR_READABLE_TEXT
        },
        containedSecondary: {
          backgroundColor: COLOR_BRIGHT_YELLOW,
          color: COLOR_READABLE_TEXT_CONTRAST,
          '&:hover': {
            backgroundColor: COLOR_BRIGHT_YELLOW
          }
        },
        containedInfo: {
          backgroundColor: COLOR_BRIGHT_YELLOW,
          color: COLOR_READABLE_TEXT_CONTRAST,
          '&:hover': {
            backgroundColor: COLOR_BRIGHT_YELLOW
          }
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          fontWeight: 300,
          color: COLOR_READABLE_TEXT_CONTRAST,
          borderRadius: '0px 0px 8px 6px',
          boxShadow: '0px 0px 3px #EDE2D7'
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {}
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: COLOR_LIGHT_BLUE,
          borderRadius: 0,
          borderBottom: '2px solid transparent',
          '&.Mui-selected': {
            background: 'initial',
            borderRadius: 0,
            color: COLOR_BRIGHT_YELLOW,
            borderColor: COLOR_BRIGHT_YELLOW
          }
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: `${COLOR_READABLE_TEXT}30`
        }
      }
    }
  },
  typography: {
    h3: {
      textTransform: 'uppercase'
    },
    h5: {
      color: COLOR_READABLE_TEXT_CONTRAST + '!important'
    }
  }
}

const CircaTheme = createTheme(defaultThemeOptions, themeOptions)

export default CircaTheme
